import React from 'react';
import { Accordion } from 'react-bootstrap';
import { FICHA_MODAL_SECTIONS, fichaModalSectionByKey } from '../../data/fichaAccordionSections';

export function FichaModalNav({ activeKey, onSelect }) {
  return (
    <nav className="ficha-modal-nav" aria-label="Secciones de la ficha">
      <p className="ficha-modal-nav__label">Secciones</p>
      <ul className="ficha-modal-nav__list">
        {FICHA_MODAL_SECTIONS.map((s) => {
          const active = activeKey === s.key;
          return (
            <li key={s.key}>
              <button
                type="button"
                className={`ficha-modal-nav__item${active ? ' ficha-modal-nav__item--active' : ''}`}
                onClick={() => onSelect(s.key)}
                aria-current={active ? 'true' : undefined}
                style={{ '--ficha-nav-color': s.color }}
              >
                <span className="ficha-modal-nav__icon">
                  <i className={`bi ${s.icon}`} aria-hidden />
                </span>
                <span className="ficha-modal-nav__text">
                  <span className="ficha-modal-nav__title">{s.title}</span>
                  <span className="ficha-modal-nav__desc">{s.desc}</span>
                </span>
                <i className="bi bi-chevron-right ficha-modal-nav__arrow" aria-hidden />
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export function FichaAccHeader({ sectionKey }) {
  const s = fichaModalSectionByKey(sectionKey);
  const slug = sectionKey.replace(/[^a-z0-9-]/gi, '');
  return (
    <Accordion.Header>
      <Accordion.Button className={`ficha-acc-hdr ficha-acc-hdr--${slug}`}>
        <span className="ficha-acc-hdr__icon" style={{ '--ficha-acc-color': s.color }}>
          <i className={`bi ${s.icon}`} aria-hidden />
        </span>
        <span className="ficha-acc-hdr__text">
          <span className="ficha-acc-hdr__title">{s.title}</span>
          {s.desc ? <span className="ficha-acc-hdr__desc">{s.desc}</span> : null}
        </span>
      </Accordion.Button>
    </Accordion.Header>
  );
}

/** Agrupa campos del formulario con título y ayuda visual. */
export function FichaFormBlock({ title, icon, hint, children, className = '' }) {
  return (
    <div className={`ficha-form-block${className ? ` ${className}` : ''}`}>
      {title ? (
        <div className="ficha-form-block__head">
          {icon ? (
            <span className="ficha-form-block__icon-wrap" aria-hidden>
              <i className={`bi ${icon}`} />
            </span>
          ) : null}
          <div className="ficha-form-block__head-text">
            <h4 className="ficha-form-block__title">{title}</h4>
            {hint ? <p className="ficha-form-block__hint">{hint}</p> : null}
          </div>
        </div>
      ) : null}
      <div className="ficha-form-block__body">{children}</div>
    </div>
  );
}

export function FichaModalIntro() {
  return (
    <div className="ficha-modal-intro">
      <i className="bi bi-info-circle" aria-hidden />
      <p>
        Complete cada sección con calma. Los datos se guardan al pulsar <strong>Guardar</strong> en el pie del
        modal.
      </p>
    </div>
  );
}

